import { useNavigate } from "react-router-dom";
import RegisterForm from "../components/registerForm";

export default function RegisterPage() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="auth-left">
        <div className="auth-brand">
          <h1 className="auth-logo">Career Engine</h1>
          <p className="auth-tagline">Land your next job, faster.</p>
        </div>
        <ul className="auth-features">
          <li><span className="auth-check">✓</span> Track every application from first look to offer</li>
          <li><span className="auth-check">✓</span> Optimize your job search through data insights</li>
          <li><span className="auth-check">✓</span> Let AI review your application before you submit</li>
        </ul>
      </div>
      <div className="auth-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Create your account</h2>
            <p className="login-card-sub">Start your job search today</p>
          </div>
          <RegisterForm onRegisterSuccess={() => navigate("/")} />
          <div className="register-link">
            <span>Already have an account?</span>
            <button onClick={() => navigate("/")}>Sign in</button>
          </div>
        </div>
      </div>
    </div>
  );
}
